const ReactSuspense = () => {
  return <div>ロード中です...</div>;
};

export default ReactSuspense;
